import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'hq-simple-dialog',
    templateUrl: './simple-dialog.component.html',
    styleUrls: ['./simple-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SimpleDialogComponent {
    title: string;
    content: string;
    actionButtonText: string;
    cancelButtonText: string;
    isDestructive: boolean;

    constructor(@Inject(MAT_DIALOG_DATA) private data: any) {
        this.title = this.data.title;
        this.content = this.data.content;
        this.actionButtonText = this.data.actionButtonText;
        this.cancelButtonText = this.data.cancelButtonText;
        this.isDestructive = this.data.isDestructive;
    }
}
